import {toast} from 'react-toastify'
import {toastDefaultConfig} from '@/shared/config/toastConfig'
import {CustomFileData} from './crud-helper/models'
import {copylinksToClipboard} from './SystemHelpers'

function copyLinkToClipboard(selectedFiles: CustomFileData[]) {
  let shareUrl: string[] = []

  selectedFiles.forEach((file: any) =>
    shareUrl.push(`${process.env.REACT_APP_SHARED_URL}${file.shareId}`)
  )

  copylinksToClipboard(shareUrl)

  toast('Copied link to clipboard!', toastDefaultConfig)
}

export {copyLinkToClipboard}
